import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';
import { ChargeParams } from '../charge.component';

@Component({
    selector: 'tt-charge-view',
    templateUrl: './charge-view.component.html',
    styleUrls: ['./charge-view.component.css'],
})
export class ChargeViewComponent {
    params: ChargeParams;

    constructor(private state: StateService) {
        this.params = state.getStateParams() as unknown as ChargeParams;
    }
}
